


















































import Vue, { PropType } from 'vue'

import StatusDetailTableRow from './StatusDetailTableRow.vue'
import { StatusData } from '../../../typings/StatusData'

export default Vue.extend({
  components: {
    StatusDetailTableRow,
  },
  props: {
    statusData: {
      type: Object as PropType<StatusData>,
      required: true
    },
    showFullTime: {
      type: Boolean,
      default: false,
    },
    wbuuid: {
      type: String as PropType<string>,
      required: true,
    },
    isOnlyStatus: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    showStatusNames: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    fontBoldTable: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    verticalRowPadding: {
      type: Number as PropType<number>
    },
    widthColumns: {
      type: Object
    },
    dynamicWidthColumns: {
      type: Object
    },
    fontSizes: {
      type: Object as PropType<object>,
      required: true
    },
    columnsSorting: {
      type: Array as PropType<any[]>,
      required: true
    },
    qualifications: {
      type: Array as PropType<any[]>,
      required: true
    },
    isEditable: {
      type: Boolean
    }
  },
  computed: {
    rowStyles() {
      return {
        'font-size': this.fontSizes.table ? `${this.fontSizes.table}px`: false,
        'padding-top': this.verticalRowPadding ? `${this.verticalRowPadding}px` : false,
        'padding-bottom':this.verticalRowPadding ?  `${this.verticalRowPadding}px` : false,
        'font-weight': this.fontBoldTable ? 'bold' : 'normal'
      }
    }
  },
  methods: {
    getBackgroundColor(): string {
      if (this.statusData.color === 'FFFF00') return '#FFCE0D' // Alternative yellow with improved contrast
      if (this.statusData.color === '00FF00') return '#00BF00' // Alternative green with improved contrast

      return `#${this.statusData.color}`
    }
  }
})
